export const ITEMS_PER_PAGE = 8

export const PIE_CHART_PAGE_SIZE = 8

export const SCORE_THRESHOLDS = {
  HIGH: 81,
  MEDIUM: 61,
} as const

export const SCORE_COLORS = {
  HIGH: '#22c55e',
  MEDIUM: '#f59e0b',
  LOW: '#ef4444',
} as const

export const POLL_CONFIG = {
  MAX_ATTEMPTS: 15,
  INTERVAL_MS: 3000,
} as const

export const CHART_DIMENSIONS = {
  MAX_WIDTH: 5000,
  MAX_BAR_WIDTH: 24,
  MIN_BAR_WIDTH: 10,
  TYPICAL_CONTAINER_WIDTH: 1200,
  BAR_CATEGORY_GAP: 0.10,
} as const

export const SESSION_STORAGE_KEY = 'storePerformance_filters'

export const SESSION_STORAGE_RESULTS_KEY = 'storePerformance_results'

export const SESSION_STORAGE_VERSIONS_KEY = 'storePerformance_versions'

export const CRITICAL_RANGE_DEFAULT: [number, number] = [0, 60]

export const MAX_VISIBLE_WEEKS = 8

export const SCROLL_DELAY_MS = 2000
